import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import { black, grey, red } from "designSystem/styles/color";
import React, { PropsWithChildren } from "react";

const PREFIX = "ChatFormField";

const classes = {
	root: `${PREFIX}root`,
	label: `${PREFIX}label`,
	children: `${PREFIX}children`,
	info: `${PREFIX}info`,
	infoIcon: `${PREFIX}infoIcon`,
	infoText: `${PREFIX}infoText`,
	error: `${PREFIX}error`,
};

const StyledGrid = styled(Grid)(({
	theme,
}) => ({
	[`&.${classes.root}`]: {
		alignItems: "stretch",
		justify: "flex-start",
		padding: theme.spacing(3),
	},

	[`& .${classes.label}`]: {
		color: black[100],
		fontSize: "12px",
		fontWeight: 700,
		lineHeight: "14px",
		paddingBottom: theme.spacing(1),
	},

	[`& .${classes.children}`]: {
		width: "100%",
	},

	[`& .${classes.info}`]: {
		color: grey["A100"],
		justify: "flex-start",
		paddingTop: theme.spacing(1.5),
	},

	[`& .${classes.infoIcon}`]: {
		height: "16px",
		width: "16px",
	},

	[`& .${classes.infoText}`]: {
		flex: 1,
		fontSize: "12px",
		fontWeight: 400,
		lineHeight: "14px",
		paddingLeft: theme.spacing(1),
	},

	[`& .${classes.error}`]: {
		// Error is at the bottom. And visible only with error, 
		// So we would like to preserve root padding, and 
		// Avoid jumping following components if error is fit into single line.
		color: red[600],
		fontSize: "12px",
		marginBottom: "-22px",
		minHeight: "22px",
		paddingTop: theme.spacing(0.5),
		paddingBottom: theme.spacing(0.5),
		width: "100%",
	},
}));

interface ChatFormFieldProps extends PropsWithChildren {
	error?: string;
	info?: string;
	label: string;
}
const ChatFormField: React.FunctionComponent<ChatFormFieldProps> = ({ label, children, error, info }) => {
	return (
		<StyledGrid
			className={classes.root}
			container
			direction="column"
		>
			<Grid className={classes.label} item>{label}</Grid>
			<Grid className={classes.children} item>{children}</Grid>
			{info
				? (
					<Grid
						className={classes.info}
						container
						direction="row"
						item
					>
						<Grid className={classes.infoIcon} item> <InfoOutlinedIcon /></Grid>
						<Grid className={classes.infoText} item>{info}</Grid>
					</Grid>
				)
				: null
			}
			<Grid className={classes.error} item>{error}</Grid>
		</StyledGrid>
	);
};

export default ChatFormField;